import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';
import ApplicationConstants from '../constants/ApplicationConstants';
import Formatter from '../utils/Formatter';

const CHANGE_EVENT = 'change';
const Constants = SelectCustomerConstants;
const ActionTypes = Constants.ActionTypes;
const ApplicationActionTypes = ApplicationConstants.ActionTypes;

let _productId,
    _clientList = [];

function setProductId(productId) {
    _productId = productId;
}

function setSearchResult(result) {
    if (!result || !result.clients) {
        _clientList = null;
        return;
    }

    _clientList = [];
    result.clients.map(function (client) {
        _clientList.push({
            id: client.oin,
            value: client.oin,
            name: Formatter.formatClientDisplayName(client.givenName, client.lastName, client.status)
        });
    });
}

class ClientResutlsStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getSearchResult() {
        return _clientList;
    }

    getProductId() {
        return _productId;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ClientResutlsStore = new ClientResutlsStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
ClientResutlsStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.CLIENT_SEARCH_COMPLETED:
            setSearchResult(action.result);
            break;

        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            break;

        default:
            return true;
    }

    ClientResutlsStore.emitChange();
    return true;
});

export default ClientResutlsStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ClientResultsStore.js